module.exports = __webpack_public_path__ + "static/img/sphs.7814f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sphs.jpg
// module id = lXqf
// module chunks = 24